import { createFileRoute } from '@tanstack/react-router'
import { Atendimento } from '@/features/atendimento/Atendimento'

export const Route = createFileRoute('/_app/app/atendimento')({
  staticData: { crumb: { label: 'Atendimento' } },
  component: Atendimento,
})
